export default {
  install (Vue, options) {
    Vue.prototype.$setSvgHref = function (path) {
      return `${process.env.BASE_URL}${path}`
    }
  }
}
